module.exports = __webpack_public_path__ + "static/media/plus.998a404e.svg";